/**
 * Severity Level Enum
 *
 * Severity (impact magnitude) of an obstruction. Mirrors backend
 * `GeoMarkup.Domain.Enums.SeverityLevel` — stored as PascalCase strings.
 */
export enum SeverityLevel {
  /** Minimal impact on traffic. */
  Low = 'Low',
  /** Noticeable but manageable impact. */
  Medium = 'Medium',
  /** Significant impact on traffic. */
  High = 'High',
  /** Critical — full closure or hazard. */
  Critical = 'Critical',
}
